import { Box, Stack, Text } from "@chakra-ui/react";
import { FormattedMessage, useIntl } from "react-intl";
import ApiErrorMessage from "../../../components/ApiErrorMessage";
import FormControlRHF from "../../../components/ReactHookForm/FormControlRHF";
import FormStateRHF from "../../../components/ReactHookForm/FormStateRHF";
import { Button, HStack } from "../../../components/ui";

/**
 * @typedef {object} Props
 * @property {import("react-hook-form").Control<import("../Create/Handler").ChannelManagerMeetingsFormValues>} control
 * @property {boolean} isLoading
 */
/**
 * @param {Props} props
 */
export function ChannelManagerMeetingsForm({ control, isLoading }) {
  const intl = useIntl();

  return (
    <Stack spacing="16px">
      <Stack spacing="4px">
        <Text
          style={{
            fontFamily: "Outfit",
            fontSize: "1.25rem",
            fontWeight: 400,
            lineHeight: "normal",
            letterSpacing: "0.025rem",
          }}>
          <FormattedMessage defaultMessage="Vous souhaitez vous abonner au Channel Manager de Clévacances ?" />
        </Text>
        <Text
          style={{
            fontFamily: "Outfit",
            fontSize: "1.25rem",
            fontWeight: 400,
            lineHeight: "normal",
            letterSpacing: "0.025rem",
          }}>
          <FormattedMessage defaultMessage="Prendre rendez-vous avec votre Équipe de Commercialisation" />
        </Text>
      </Stack>
      <ApiErrorMessage withCaughtErrors={true} />

      <Box>
        <FormControlRHF
          control={control}
          name="data.message"
          rules={{ maxLength: 1000 }}
          type="textarea"
          withCharactersCounter={true}
          label={intl.formatMessage({
            defaultMessage: "Message",
          })}
        />
      </Box>

      <HStack justify="flex-end">
        <FormStateRHF
          render={({ isDirty }) => (
            <Button
              type="submit"
              isLoading={isLoading}
              isDisabled={!isDirty}
              colorScheme="orange"
              backgroundColor="#F95E24">
              <Text variant="button" color="#fff !important">
                <FormattedMessage defaultMessage="Prendre rendez-vous" />
              </Text>
            </Button>
          )}
        />
      </HStack>
    </Stack>
  );
}
